import { render, staticRenderFns } from "./DeathAttributes.vue?vue&type=template&id=6e9f7464&scoped=true&"
import script from "./DeathAttributes.vue?vue&type=script&lang=js&"
export * from "./DeathAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9f7464",
  null
  
)

export default component.exports